// frontend/src/App.jsx
import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/admin/Login';
import Dashboard from './pages/admin/Dashboard';
import SignPage from './pages/customer/SignPage';
import { Toast, Spinner, C } from './components/UI';

function AdminApp() {
  const [email,  setEmail]  = useState(null);
  const [ready,  setReady]  = useState(false);
  const [toast,  setToast]  = useState(null);

  useEffect(() => {
    const t = localStorage.getItem('akcoda_token');
    const e = localStorage.getItem('akcoda_email');
    if (t && e) setEmail(e);
    setReady(true);
  }, []);

  const showToast = (message, type = 'success') => setToast({ message, type });

  function handleLogout() {
    localStorage.removeItem('akcoda_token');
    localStorage.removeItem('akcoda_email');
    setEmail(null);
  }

  if (!ready) return (
    <div style={{ minHeight: '100vh', background: C.bg, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Spinner size={40} />
    </div>
  );

  if (!email) return <Login onLogin={setEmail} />;

  return (
    <div style={{ minHeight: '100vh', background: C.bg, fontFamily: "'Inter', system-ui, sans-serif" }}>
      {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}
      <div style={{ background: C.surface, borderBottom: `1px solid ${C.border}`, padding: '0 36px', height: 60, display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'sticky', top: 0, zIndex: 200 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{ width: 32, height: 32, borderRadius: 9, background: 'linear-gradient(135deg,#403DD4,#6a68e8)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16 }}>⚡</div>
          <span style={{ fontSize: 17, fontWeight: 800, color: C.text, letterSpacing: '-0.3px' }}>AKCODA</span>
        </div>
        <div style={{ fontSize: 12, color: C.muted }}>agreement.akcoda.in</div>
      </div>
      <div style={{ maxWidth: 1140, margin: '0 auto', padding: '36px 28px' }}>
        <Dashboard adminEmail={email} onLogout={handleLogout} showToast={showToast} />
      </div>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/"         element={<AdminApp />} />
        <Route path="/sign/:id" element={<SignPage />} />
        <Route path="*"         element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
